const objectKeys = [
  'object_type',
  'object_id',
  'image_set',
  'image_type',
] as const;

const eventsReadingObjectKeys = ['component', 'system'];

/**
 * GTM keeps every dataLayer key until a later push overwrites it, and the GTM
 * tags of component and system events read these keys. Such an event that does
 * not describe an object would otherwise inherit the object of an earlier
 * event, e.g. checkout_start carrying the product of a gallery swipe.
 */
export const withClearedObjectKeys = <T extends object>(event: T): T => {
  if (
    !('event' in event) ||
    !eventsReadingObjectKeys.includes(event.event as string)
  ) {
    return event;
  }

  return {
    ...Object.fromEntries(objectKeys.map(key => [key, undefined])),
    ...event,
  };
};
